<div class="auth-container">
  <app-home-page [showLeft]="(showSamlAuth$ | async) === false">
    <app-auth-dashboard-left-side
      left
      name="left-col"
    ></app-auth-dashboard-left-side>

    <router-outlet
      right
      *ngIf="(showSamlAuth$ | async) === false; else samlAuth"
    ></router-outlet>
  </app-home-page>
</div>

<!-- Saml Auth -->
<ng-template #samlAuth>
  <app-saml-login
    [customSubdomain]="(selectCustomSubdomain$ | async) ?? ''"
  ></app-saml-login>
</ng-template>
